<button
    mat-stroked-button
    id="btn-request-finance"
    color="primary"
    (click)="sendRequestFinanceSupport()"
    [disabled]="sprintPayFlexButtonDisabled"
>
    {{ sprintPayFlexButtonText }}
</button>
